var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.loading),expression:"loading",modifiers:{"fullscreen":true,"lock":true}}],attrs:{"element-loading-text":_vm.text,"element-loading-spinner":_vm.icon,"element-loading-background":_vm.background}})
}
var staticRenderFns = []

export { render, staticRenderFns }